require('./capability_ng_major_explorer_module.ts');
require('./components/major_coursemap_view_content/major_coursemap_view_content_controller.ts');
require('./components/major_credentials_view_content/major_credentials_view_content_controller.ts');
require('./components/major_detail_view_content/major_detail_view_content_controller.ts');
require('./components/major_dev_courses_view_content/major_dev_courses_view_content_controller.ts');
require('./components/major_search_view_content/major_search_view_content_controller.ts');
require('./components/major_sort_filter/major_sort_filter_controller.ts');
require('./components/major_tile/major_tile_controller.ts');
require('./components/major_tile_career/major_tile_career_controller.ts');
require('./components/major_tile_careers_list/major_tile_careers_list_controller.ts');
require('./components/phx_delegate_tag/delegate_tag_component.es.js');
require('./components/survey_begin_view_content/survey_begin_view_content_controller.ts');
require('./components/survey_question/survey_question_directive.js');
require('./components/survey_question_choice/survey_question_choice_controller.ts');
require('./components/survey_question_generic/survey_question_generic.ts');
require('./components/survey_question_listselection/survey_question_listSelection_controller.ts');
require('./components/survey_question_metaranking/survey_question_metaranking_controller.ts');
require('./components/survey_question_programs/survey_question_programs_controller.ts');
require('./components/survey_question_rank/survey_question_rank_controller.ts');
require('./components/survey_step_footer/survey_step_footer.ts');
require('./components/survey_step_view_content/survey_step_view_content_controller.ts');
require('./configuration.ts');
require('./data/builders/major_course_map_course_builder.ts');
require('./data/builders/major_course_map_program_builder.ts');
require('./data/builders/major_credential_builder.ts');
require('./data/builders/major_dev_course_builder.ts');
require('./data/builders/major_listselection_builder.ts');
require('./data/builders/major_metaranking_builder.ts');
require('./data/builders/major_programs_builder.ts');
require('./data/commands/delete_metaranking_command.ts');
require('./data/commands/get_reminder_about_majors_command.ts');
require('./data/commands/load_developmental_courses_command.ts');
require('./data/commands/load_favorite_programs_command.ts');
require('./data/commands/load_listselection_command.ts');
require('./data/commands/load_major_detail_command.ts');
require('./data/commands/load_major_explorer_intake_command.ts');
require('./data/commands/load_metaranking_command.ts');
require('./data/commands/load_program_programslot_command.ts');
require('./data/commands/load_programs_command.ts');
require('./data/commands/load_related_careers_command.ts');
require('./data/commands/load_search_programs_command.ts');
require('./data/commands/load_student_current_major_command.ts');
require('./data/commands/save_choice_question_command.ts');
require('./data/commands/save_item_command.ts');
require('./data/commands/save_list_selection_activity_command.ts');
require('./data/commands/save_list_selection_subject_command.ts');
require('./data/commands/save_major_command.ts');
require('./data/commands/save_metaranking_command.ts');
require('./data/commands/save_reminder_about_majors_command.ts');
require('./data/commands/unsave_major_command.ts');
require('./data/configs/my_intake_model_configuration.ts');
require('./data/datasources/major_course_map_course_datasource.ts');
require('./data/datasources/major_course_map_program_datasource.ts');
require('./data/datasources/major_credential_datasource.ts');
require('./data/datasources/major_current_majors_datasource.ts');
require('./data/datasources/major_dev_courses_datasource.ts');
require('./data/datasources/major_program_datasource.ts');
require('./data/functions/choice_question_fn.ts');
require('./data/functions/list_selection_fn.ts');
require('./data/functions/major_explorer_user_activity_fn.ts');
require('./data/functions/major_tile_fn.ts');
require('./data/functions/metaranking_fn.ts');
require('./data/functions/programs_fn.ts');
require('./data/major_explorer_data_module.ts');
require('./data/models/major_program_model.ts');
require('./data/models/my_intake_history_model.ts');
require('./data/models/my_intake_model.es.js');
require('./data/queries/major_course_map_query.ts');
require('./data/queries/major_credential_query.ts');
require('./data/queries/major_current_majors_query.ts');
require('./data/queries/major_dev_courses_query.ts');
require('./data/queries/major_programs_query.ts');
require('./data/servants/major_builder_servant.ts');
require('./data/services/major_data_toggle_service.ts');
require('./data/services/major_search_service.ts');
require('./data/services/major_service.ts');
require('./data/services/survey_step_service.ts');
require('./data/types/hiring_trend_enum.ts');
require('./data/types/major_explorer_user_activity_name_enum.ts');
require('./data/types/program_sort_enum.ts');
require('./data/types/programs_presenter_view_state.ts');
require('./major_explorer_interface.ts');
require('./modals/about_data_modal/survey_about_our_data_modal.ts');
require('./modals/about_program_results_modal/survey_about_program_results_modal.ts');
require('./modals/metaranking_modal/survey_metaranking_modal.ts');
require('./modals/view_interests_modal/survey_view_your_interests_modal.ts');
require('./routes.ts');
require('./views/major_course_map/major_course_map_controller.ts');
require('./views/major_detail/major_detail_controller.ts');
require('./views/major_placement_scores/major_placement_scores_controller.ts');
require('./views/major_survey_begin/major_survey_begin_controller.ts');
require('./views/major_survey_step/major_survey_step_controller.ts');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/core.ts